var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.99,
    height: 38.041,
    viewBox: "0 0 37.99 38.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel_1_",
    "data-name": "cancel (1)",
    transform: "translate(-0.301 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14940",
    "data-name": "Path 14940",
    d: "M34.145,35.1c-5.821,4.752-24,4.752-29.7,0-5.821-4.752-5.227-25.065,0-30.411s24.472-5.346,29.7,0S39.966,30.344,34.145,35.1Z",
    transform: "translate(0 -0.618)",
    fill: "#c36432"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6597",
    "data-name": "Group 6597",
    transform: "translate(0.318 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14941",
    "data-name": "Path 14941",
    d: "M19.606,26.162A27.814,27.814,0,0,1,3.094,32.577C-.945,25.686-.114,8.937,4.638,4.066c4.277-4.4,17.7-5.227,25.422-2.495C31.961,9.412,28.04,19.39,19.606,26.162Z",
    transform: "translate(-0.509 0)",
    fill: "#ce6f3d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14942",
    "data-name": "Path 14942",
    d: "M131.817,131.977a2.012,2.012,0,0,1-2.732,0l-6.3-6.3-6.3,6.3a1.932,1.932,0,0,1-2.732-2.732l6.415-6.3-6.415-6.3a1.932,1.932,0,1,1,2.732-2.732l6.3,6.415,6.3-6.415a1.932,1.932,0,0,1,2.732,2.732l-6.3,6.3,6.3,6.3A1.807,1.807,0,0,1,131.817,131.977Z",
    transform: "translate(-103.493 -103.915)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.992ff19a.svg";
export { ForwardRef as ReactComponent };